import { motion } from "framer-motion";
import { ArrowRight, Briefcase, Sparkles } from "lucide-react";

const services = [
  "Web application",
  "Mobile app",
  "Backend API",
  "Dashboard monitoring",
  "IoT device integration",
  "Hardware prototype",
  "AI & data analytics",
  "Cloud deployment",
  "System integration",
  "Konsultasi produk teknologi",
];

const Freelance = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="freelance" data-testid="freelance-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-16 glass-elevated glow-border"
        >
          {/* decorative blobs */}
          <div className="absolute -top-24 -right-20 w-80 h-80 bg-blue-500/20 rounded-full blur-[100px]" />
          <div className="absolute -bottom-24 -left-20 w-80 h-80 bg-violet-500/20 rounded-full blur-[100px]" />
          <div className="absolute inset-0 grid-bg-fine opacity-40" />

          {/* status pill */}
          <div className="absolute top-6 right-6 z-10 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-400/30">
            <span className="relative flex w-1.5 h-1.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
              <span className="relative inline-flex w-1.5 h-1.5 rounded-full bg-emerald-400" />
            </span>
            <span className="text-[10px] uppercase tracking-[0.22em] text-emerald-300 font-mono-display">
              Open for project
            </span>
          </div>

          <div className="relative grid lg:grid-cols-[1.1fr_0.9fr] gap-10 lg:gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-blue-400 font-mono-display">
                <Briefcase className="w-3.5 h-3.5" strokeWidth={1.5} />
                /// Freelance Service
              </div>
              <h2
                className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white"
                style={{ fontFamily: "Outfit" }}
                data-testid="freelance-title"
              >
                Menerima freelance project{" "}
                <span className="text-gradient-aurora">software &amp; hardware.</span>
              </h2>
              <p className="mt-5 text-base text-slate-300 leading-relaxed max-w-xl">
                Terbuka untuk kerja sama pengembangan web application, mobile app, backend API,
                dashboard monitoring, IoT device integration, hardware prototype, AI &amp; data
                analytics, cloud deployment, system integration, dan konsultasi produk teknologi.
              </p>

              <button
                data-testid="freelance-cta"
                onClick={() => scrollTo("contact")}
                className="mt-8 group relative inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium shadow-[0_0_30px_rgba(59,130,246,0.4)] hover:shadow-[0_0_50px_rgba(59,130,246,0.6)] transition-shadow duration-300 overflow-hidden"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 via-cyan-300/25 to-cyan-400/0 -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
                <Sparkles className="w-4 h-4" strokeWidth={1.75} />
                Diskusikan Project
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
              </button>
            </div>

            <div className="flex flex-wrap gap-2.5" data-testid="freelance-services">
              {services.map((s, i) => (
                <motion.span
                  key={s}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.04, duration: 0.35 }}
                  className="px-3.5 py-2 rounded-full text-xs border border-white/10 bg-white/[0.03] text-slate-200 hover:bg-blue-500/10 hover:border-blue-400/40 transition-colors font-mono-display"
                  data-testid={`freelance-service-${i}`}
                >
                  {s}
                </motion.span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Freelance;
